import { Component } from '@angular/core';
import { CostOutageCountiesCalculatedWidgetComponent } from '../widgets/cost-outage-counties-calculated-widget/cost-outage-counties-calculated-widget.component';
import { CostOutageResidentialCostWidgetComponent } from '../widgets/cost-outage-residential-cost-widget/cost-outage-residential-cost-widget.component';
import { EconomicCostPerCustomerWidgetComponent } from '../widgets/economic-cost-per-customer-widget/economic-cost-per-customer-widget.component';
import { EconomicCostRankingWidgetComponent } from '../widgets/economic-cost-ranking-widget/economic-cost-ranking-widget.component';
import { EconomicCostTotalWidgetComponent } from '../widgets/economic-cost-total-widget/economic-cost-total-widget.component';

@Component({
  selector: 'tgrid-cost-outage-page',
  templateUrl: './cost-outage-page.component.html',
  standalone: true,
  imports: [
    CostOutageCountiesCalculatedWidgetComponent,
    CostOutageResidentialCostWidgetComponent,
    EconomicCostPerCustomerWidgetComponent,
    EconomicCostTotalWidgetComponent,
    EconomicCostRankingWidgetComponent,
  ],
  styleUrls: ['./cost-outage-page.component.scss'],
})
export class CostOutagePageComponent { }
